import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import I18n from '../i18n';
import ProgressBar from 'react-bootstrap/ProgressBar';

export default function Progress(props) {
  const {className, data, ...rest} = props;

  function maxValue() {
    let sum = 0;
    data.map(item => {
      sum = sum + item.value;
    });
    return sum;
  }

  function percentageValue(value) {
    return ((value / maxValue()) * 100).toFixed(1);
  }

  return (
    <div className="progress-chart">
      {data.map((item, index) => (
        <div key={index}>
          <span className="progress-bar-name">{I18n.t(item.label)} </span>
          <span className="progress-bar-percent">{percentageValue(item.value)}%</span>
          <span className="progress-bar-value">{item.value}</span>
          <ProgressBar
            className={classnames(className)}
            variant={item.variant}
            key={index}
            now={item.value}
            max={maxValue()}
            {...rest}
          />
        </div>
      ))}
    </div>
  );
}

Progress.defaultProps = {};

Progress.propTypes = {
  /** An optional className to add to the HTML element. */
  className: PropTypes.string,
  /** Represents chart data. */
  data: PropTypes.array,
};
